import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const PullQuote = ({
  key,
  quoteContent=null,
  name=null,
  jobTitle=null,
  photo=null
}) => {

  const photoUrl = (photo?.formats?.medium) ? photo.formats.medium.url : photo?.url
  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <div className="case-study-module case-study-pull-quote-block customer_spotlight_block bgg1 df jcc">
      <div className="col-11 col-md-10 col-xl-9  testimonial-static ph0">
        <div className="d-flex flex-wrap">
          <div className={ `col-12 ${photo ? "col-md-7 pl0" : ""} spotlight-inner` }>
            <div className="quotes">
              {quoteContent &&
                <div className="copy" dangerouslySetInnerHTML={{ __html: quoteContent }} />
              }
              <div className="cust-info">
                {name &&
                  <span className="name">{ htmlDecode(name) }</span>
                }
                {jobTitle &&
                  <span className="position">{ htmlDecode(jobTitle) }</span>
                }
                <br />
              </div>
            </div>
          </div>
          {photo &&
            <div className="col-12 col-md-5 col-xl-4 offset-xl-1 cust-img-wrap">
              <img className="cust-img" src={photoUrl.includes(cdnUrl) ? photoUrl : cdnUrl + photoUrl} alt={ photo?.alternativeText } style={{ zIndex: "10" }} />
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default PullQuote
